/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import Table, { TableSize } from '@components/Table';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import TooltipText from '@components/v2/TooltipText';
import ConfirmDialog from '@components/ConfirmDialog/ConfirmDialog';
import { useToggleComponentTypeStatusMutation } from './hooks/useComponentTypesMutations';
const namespace = 'features.settings.component_types';
function TypeRenderer({ item }) {
    return (React.createElement("div", { className: "component-type-row" },
        React.createElement("div", { className: "component-type-info" },
            React.createElement("div", { className: "component-type-name" }, item.typeName),
            React.createElement("div", { className: "component-type-count" },
                item.componentsCount,
                " ",
                translate('components', { namespace })))));
}
function ActionsRenderer({ item, onEditClick }) {
    const editLabel = translate('edit', { namespace: 'generic' });
    const actionLabel = item.active
        ? translate('deactivate', { namespace: 'features.commons' })
        : translate('activate', { namespace: 'features.commons' });
    const toggleStatusMutation = useToggleComponentTypeStatusMutation();
    const [isActionConfirmOpen, setIsActionConfirmOpen] = useState(false);
    const handleEditClick = () => {
        if (onEditClick) {
            onEditClick(item);
        }
    };
    const handleActionClick = () => {
        setIsActionConfirmOpen(true);
    };
    const handleConfirmAction = () => {
        toggleStatusMutation.mutate(item.id);
        setIsActionConfirmOpen(false);
    };
    const handleCancelAction = () => {
        setIsActionConfirmOpen(false);
    };
    return (React.createElement("div", { className: "component-actions-row" },
        React.createElement(TooltipText, { text: editLabel },
            React.createElement(Button, { "aria-label": `${editLabel} ${item.typeName}`, onClick: handleEditClick },
                React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" }))),
        React.createElement(TooltipText, { text: actionLabel },
            React.createElement(Button, { "aria-label": `${actionLabel} ${item.typeName}`, onClick: handleActionClick },
                React.createElement("i", { className: item.active ? 'fa-light fa-ban' : 'fa-light fa-check-circle', "aria-hidden": "true" }))),
        isActionConfirmOpen && (React.createElement(ConfirmDialog, { title: translate(item.active ? 'deactivate_type_title' : 'activate_type_title', { namespace }), description: translate(item.active ? 'deactivate_type_description' : 'activate_type_description', {
                namespace
            }), onConfirm: handleConfirmAction, onCancel: handleCancelAction, yesLabel: translate(item.active ? 'deactivate' : 'activate', { namespace: 'features.commons' }), noLabel: translate('cancel', { namespace: 'features.commons' }) }))));
}
export default function ComponentTypesTable({ componentTypes, onEditClick, canEdit = false }) {
    const columns = [
        {
            label: translate('type_column', { namespace }),
            dataKey: 'typeName',
            renderer: (props) => React.createElement(TypeRenderer, { item: props.item })
        },
        {
            label: translate('description_column', { namespace }),
            dataKey: 'description',
            renderer: (props) => React.createElement("span", null, props.item.description || '--')
        },
        {
            label: translate('category_column', { namespace }),
            dataKey: 'category',
            renderer: (props) => React.createElement("span", null, props.item.category || '--')
        },
        {
            label: translate('fields_column', { namespace }),
            dataKey: 'fieldsCount',
            renderer: (props) => React.createElement("span", null, props.item.fieldsCount)
        },
        ...(canEdit
            ? [
                {
                    label: '',
                    dataKey: 'actions',
                    renderer: (props) => (React.createElement(ActionsRenderer, { item: props.item, onEditClick: onEditClick }))
                }
            ]
            : [])
    ];
    const sortedComponentTypes = [...componentTypes].sort((a, b) => a.typeName.localeCompare(b.typeName));
    return React.createElement(Table, { columns: columns, data: sortedComponentTypes, size: TableSize.Full, variant: "detail" });
}
